<script setup lang="ts">
import TelegramSupportButton from '@/widgets/telegramSupportButton/index';
import {
  FIRST_PHONE_NUMBER,
  SECOND_PHONE_NUMBER,
  COMPANY_EMAIL,
} from '@/shared/constants/contacts';

const { t } = useI18n();
</script>

<template>
  <div class="contacts-section">
    <div class="contacts-section__section">
      <h1 class="contacts-section__title">
        {{ t('forBusinessPage.contactsSectionTitle') }}
      </h1>
      <div class="contacts-section__content">
        <div class="contacts-section__content-item _text">
          <div class="contacts-section__item">
            <div class="contacts-section__item-title">{{ t('location') }}</div>
            <a
              href="https://yandex.uz/maps/-/CHXbIQND"
              target="_blank"
              :aria-label="t('openInYandexMaps')"
              class="contacts-section__item-link _geo"
            >
              {{ t('contactsAddress') }}
            </a>
          </div>
          <div class="contacts-section__item">
            <div class="contacts-section__item-title">{{ t('contactsPhones') }}</div>
            <div class="contacts-section__text-wrapper">
              <div class="contacts-section__item-text">
                <a
                  :href="`tel:${FIRST_PHONE_NUMBER}`"
                  class="contacts-section__item-link"
                  :aria-label="t('phoneNumber')"
                >
                  {{ FIRST_PHONE_NUMBER }}
                </a>
                {{ t('arina') }}
              </div>
              <div class="contacts-section__item-text">
                <a
                  :href="`tel:${SECOND_PHONE_NUMBER}`"
                  class="contacts-section__item-link"
                  :aria-label="t('phoneNumber')"
                >
                  {{ SECOND_PHONE_NUMBER }}
                </a>
                {{ t('firuza') }}
              </div>
              <div class="contacts-section__item-text _time">
                {{ t('contactsWorkingTime') }}
              </div>
            </div>
          </div>
          <div class="contacts-section__item">
            <div class="contacts-section__item-title">{{ t('email') }}</div>
            <a
              href="mailto:info@resource.com"
              class="contacts-section__item-link"
              :aria-label="t('contactsEmail')"
            >
              {{ COMPANY_EMAIL }}
            </a>
          </div>
          <div class="contacts-section__item _button">
            <TelegramSupportButton />
          </div>
        </div>
        <div class="contacts-section__content-item">
          <a
            href="https://yandex.uz/maps/-/CHXbIQND"
            target="_blank"
            :aria-label="t('openInYandexMaps')"
          >
            <NuxtImg
              src="/images/map.webp"
              :alt="t('contacts')"
              class="contacts-section__map"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less">
.contacts-section {
  &__title {
    .h-offset-reset();

    font-size: 48px;
    font-weight: 500;
    line-height: 115%;
  }

  &__section {
    .flex-column(@size-x8);
  }

  &__content {
    display: flex;
    justify-content: space-between;
    gap: @size-x6;
  }

  &__content-item {
    width: 100%;

    &._text {
      .flex-column(@size-x6);

      background-color: @color-athens-gray;
      padding: @size-x8;
      border-radius: @size-x6;
    }
  }

  &__text-wrapper {
    .flex-column(@size-x2);
  }

  &__item {
    .flex-column(@size-x3);

    &._button {
      max-width: 230px;
    }
  }

  &__item-title {
    font-size: @size-x5;
    font-weight: 600;
    line-height: 100%;
  }

  &__item-text,
  &__item-link {
    font-size: 18px;
    font-weight: 500;
    line-height: 125%;

    &._time {
      font-size: @size-x4;
      line-height: 130%;
      color: @color-dove-gray-secondary;
    }
  }

  &__item-link {
    .color-change-hover();

    &:not(._geo) {
      color: @color-tango;
    }
  }

  &__map {
    display: block;
    width: 100%;
    max-width: 700px;
    height: 410px;
    object-fit: cover;
    border-radius: @size-x6;
  }

  @media @1024 {
    &__title {
      font-size: @size-x6;
    }

    &__section {
      gap: @size-x4;
    }

    &__content {
      flex-direction: column;
    }

    &__content-item {
      &._text {
        padding: @size-x6 @size-x4;
      }
    }

    &__item-title {
      font-size: 18px;
    }

    &__item-text,
    &__item-link {
      font-size: @size-x4;

      &._time {
        font-size: 14px;
      }
    }

    &__map {
      max-width: 100%;
      height: 180px;
    }
  }
}
</style>
